import { httpService as a } from "@waitroom/http-client";
import { buildApiParams as t } from "../helpers.es.js";
const p = {
  getPlans: async (i) => a.get(await t("/billing/plans", { ...i })),
  getPlan: async (i, n) => a.get(
    await t(`/billing/plans/${i}`, {
      ...n
    })
  )
};
export {
  p as subscriptionPlanApiService
};
